export default __webpack_public_path__ + "static/media/blog_detail1.8b420e33.webp";